import { AutoFormFieldProps } from "@autoform/react";
import React from "react";
import CustomTimePicker from "@components/FormFields/CustomTimePicker";

export const TimeField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
}) => {
  const { key, ...props } = inputProps;

  return (
    <CustomTimePicker
      key={key}
      id={id}
      className={error ? "border-destructive" : ""}
      {...props}
    />
  );
};
